/**
 * Intelligence platform + insights actions
 */
export const INTELLIGENCE_ACTIONS = {
  DASHBOARD_VIEWED: 'dashboard_viewed',
  COUNTRY_SELECTED: 'country_selected',
  INDICATOR_CHANGED: 'indicator_changed',
  REPORT_GENERATED: 'report_generated',
  DATA_EXPORTED: 'data_exported',
  COMPARISON_ADDED: 'comparison_added',
  MODULE_VIEWED: 'module_viewed',
  // CountrySearch
  QUERY: 'query',
  SELECT: 'select',
  CLEAR: 'clear',
  // InsightDashboard
  VIEW: 'view',
  EXPORT_CSV: 'export_csv',
  OPEN_HELP_MODAL: 'open_help_modal',
  OPEN_INSIGHTS_GUIDE: 'open_insights_guide',
} as const;
